var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommunityPostSettings } from '@amityco/js-sdk';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { info } from '../../../core/components/Confirm';
import useCommunity from '../../../social/hooks/useCommunity';
function getValue(key, community) {
    if (key === 'needApprovalOnPostCreation') {
        return community.postSetting === CommunityPostSettings.ADMIN_REVIEW_POST_REQUIRED;
    }
    return community[key];
}
function getPatch(key, value) {
    if (key === 'needApprovalOnPostCreation') {
        return {
            postSetting: value
                ? CommunityPostSettings.ADMIN_REVIEW_POST_REQUIRED
                : CommunityPostSettings.ANYONE_CAN_POST,
        };
    }
    return { [key]: value };
}
export function usePermission(communityId, key) {
    const { community, updateCommunity } = useCommunity(communityId);
    const prevValue = getValue(key, community);
    const [permission, setPermissionState] = useState(prevValue);
    useEffect(() => setPermissionState(prevValue), [prevValue]);
    const setPermission = useCallback((newValue) => __awaiter(this, void 0, void 0, function* () {
        try {
            setPermissionState(newValue);
            yield updateCommunity(getPatch(key, newValue));
        }
        catch (error) {
            setPermissionState(prevValue);
            info({
                title: (React.createElement(FormattedMessage, { id: `community.permissions.error.${key}.${newValue ? 'turnOn' : 'turnOff'}` })),
                content: error.message,
            });
        }
    }), [key, prevValue, updateCommunity]);
    return [permission, setPermission];
}
//# sourceMappingURL=utils.js.map